/**
 * Responsive CSS for footer blocks in sent emails and preview iframe.
 */
export const FOOTER_EMAIL_BASE_CSS = `
  .footer-social-row {
    width: auto !important;
    max-width: none !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }
  .footer-social-row a.footer-social-link {
    display: inline-block !important;
    max-width: none !important;
    width: auto !important;
    text-decoration: none !important;
    vertical-align: middle !important;
    line-height: 0 !important;
    margin: 0 !important;
  }
  .footer-social-row .footer-social-btn,
  .footer-social-row .footer-social-btn table {
    display: inline-table !important;
    max-width: none !important;
    table-layout: fixed !important;
    border-collapse: collapse !important;
    margin: 0 !important;
  }
  .footer-social-row .footer-social-btn td.footer-social-btn-cell {
    max-width: none !important;
    box-sizing: border-box !important;
    text-align: center !important;
    vertical-align: middle !important;
    line-height: 0 !important;
    padding: 0 !important;
  }
  .footer-social-row .footer-social-btn img.footer-social-icon-img {
    display: block !important;
    margin: 0 auto !important;
    max-width: none !important;
    min-width: auto !important;
    height: auto !important;
  }
`;

export const FOOTER_RESPONSIVE_CSS = `
  @media only screen and (max-width: 768px) {
    .footer-complete-bottom > tbody > tr > td {
      display: block !important;
      width: 100% !important;
      text-align: center !important;
      box-sizing: border-box !important;
    }
    .footer-link-row > tbody > tr > td {
      display: block !important;
      width: 100% !important;
      text-align: center !important;
    }
    .footer-complete-bottom .footer-social-row {
      margin-left: auto !important;
      margin-right: auto !important;
    }
  }
`;

/** Builder canvas — locks social icon boxes (overrides Tailwind preflight on svg/img). */
export const FOOTER_BUILDER_CSS = `
  .footer-social-icons-row {
    width: auto !important;
    max-width: 100% !important;
  }
  .footer-social-icon-box {
    display: inline-grid !important;
    place-items: center !important;
    width: var(--footer-social-box) !important;
    height: var(--footer-social-box) !important;
    min-width: var(--footer-social-box) !important;
    max-width: var(--footer-social-box) !important;
    min-height: var(--footer-social-box) !important;
    max-height: var(--footer-social-box) !important;
    flex: 0 0 auto !important;
    flex-shrink: 0 !important;
    box-sizing: border-box !important;
    padding: 0 !important;
    margin: 0 !important;
    line-height: 0 !important;
    text-decoration: none !important;
    overflow: hidden !important;
    vertical-align: middle !important;
  }
  .footer-social-icon-box svg,
  .footer-social-icon-box img,
  .footer-social-icon-box .footer-social-icon-graphic {
    display: block !important;
    width: var(--footer-social-icon) !important;
    height: var(--footer-social-icon) !important;
    min-width: var(--footer-social-icon) !important;
    max-width: var(--footer-social-icon) !important;
    min-height: var(--footer-social-icon) !important;
    max-height: var(--footer-social-icon) !important;
    margin: 0 auto !important;
  }
  .footer-complete-bottom .footer-social-icons-row,
  .footer-complete-social .footer-social-icons-row {
    flex-direction: row !important;
    flex-wrap: nowrap !important;
  }
  .footer-complete-bottom td.footer-complete-social-cell {
    width: auto !important;
    white-space: nowrap !important;
  }
`;

/** Builder mobile/tablet canvas — scoped to wrapper class. */
export const FOOTER_BUILDER_MOBILE_CSS = `
  .email-canvas-mobile .footer-complete-bottom > tbody > tr > td,
  .email-canvas-tablet .footer-complete-bottom > tbody > tr > td {
    display: block !important;
    width: 100% !important;
    text-align: center !important;
  }
  .email-canvas-mobile .footer-complete-bottom .footer-complete-social-cell,
  .email-canvas-tablet .footer-complete-bottom .footer-complete-social-cell {
    white-space: normal !important;
  }
  .email-canvas-mobile .footer-social-icons-row,
  .email-canvas-tablet .footer-social-icons-row,
  .email-canvas-mobile .footer-complete-bottom .footer-social-icons-row,
  .email-canvas-tablet .footer-complete-bottom .footer-social-icons-row {
    justify-content: center !important;
    margin-left: auto !important;
    margin-right: auto !important;
    flex-wrap: nowrap !important;
  }
`;
